import React, { useCallback, useEffect, useState } from 'react';
import { firestore } from '../contexts/FirebaseContext';
import { getSaldoType } from '../utils/formatWallet';

function useGetUserWallet(userId) {
  const [userWallet, setUserWallet] = useState({});
  //   const [saldoType, setSaldoType] = useState('');
  // para obtener el saldo esecifico de la wallet

  //   const getTypeSaldo = useCallback(() => {
  //     const index = getSaldoType(saldoId);
  //     const tipoSaldo = userWallet[index];

  //     setSaldoType(tipoSaldo);
  //   }, [saldoId, userWallet]);

  // para obtener la wallet completa del usuario
  // const getWallet = useCallback(async () => {
  //   // const wallet = await (await firestore.collection('wallets').doc(userId).get()).data();
  //   // console.log(wallet);
  //   // setUserWallet(wallet);

  //   const wallet = await (await firestore.collection('wallets').doc(userId).onSnapshot(snapshot => {
  //     setUserWallet(snapshot.data())
  //   })
  //   // if (saldoId) {
  //   //   getTypeSaldo();
  //   // }
  //   // return wallet;
  // }, [userId]);

  useEffect(() => {
    async function getWallet() {
      await firestore
        .collection('wallets')
        .doc(userId)
        .onSnapshot((snapshot) => {
          setUserWallet(snapshot.data());
        });
    }
    getWallet();
  }, [userId]);

  return { userWallet };
}

export default useGetUserWallet;
